import { usePeopleSearch } from "@/contexts/PeopleSearchContext";
import { KeywordClauseEditor } from "../KeywordClauseEditor";

export function KeywordsPanel() {
	const { draft, updateDraft } = usePeopleSearch();

	return (
		<KeywordClauseEditor
			value={draft.keywords}
			onChange={keywords => updateDraft('keywords', keywords)}
		/>
	);
}
